import { useState, useEffect } from "react"
import debounce from "lodash.debounce"

const useDebouncedFiltering = ({
  initialQuery = "",
  items = [],
  filterBy = () => true,
  delay = 800,
}) => {
  const [searchQuery, setSearchQuery] = useState(initialQuery)
  const [filteredItems, setFilteredItems] = useState(items)

  const debouncedSearch = debounce((value) => {
    setFilteredItems(value ? items.filter((item) => filterBy(value, item)) : items)
  }, delay)

  useEffect(() => {
    debouncedSearch(searchQuery)
  }, [searchQuery, debouncedSearch])

  return {
    searchQuery,
    setSearchQuery,
    filteredItems,
  }
}

export default useDebouncedFiltering
